import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import PlayNoticeProvider from "@/components/feature/PlayNoticeProvider";

export default function SiteLayout() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, search]);

  return (
    <PlayNoticeProvider>
      <div className="min-h-screen flex flex-col bg-background-50">
        <SiteNavbar />
        <main className="flex-1 w-full">
          <Outlet />
        </main>
        <SiteFooter />
      </div>
    </PlayNoticeProvider>
  );
}